@if (readonly()) {
  <new-ui-wrapper-readonly
    [label]="label()"
    [value]="
      ngControl.value | newUiLabel: options() : optionValue() ?? null : optionLabel() ?? null : null : null : false
    "
  />
}

<new-ui-wrapper-writable [class.hidden]="readonly()" [label]="label()" [required]="required()" [pristine]="ngControl.pristine">
    <p-selectbutton
      class="flex"
      [formControl]="$any(ngControl.control)"
      [options]="options()"
      [optionLabel]="optionLabel() ?? undefined"
      [optionValue]="optionValue() ?? undefined"
      [allowEmpty]="allowEmpty()"
      [multiple]="multiple()"
      (onChange)="changed.emit($event)"
    />
  </new-ui-wrapper-writable>
